<p-table
	[value]="paginationResult.entities"
	[lazy]="true"
	(onLazyLoad)="loadData($event)"
	[rows]="paginationRequest.pageSize"
	[totalRecords]="paginationResult.filteredEntities"
	[rowsPerPageOptions]="[10, 20, 30, 40, 50]"
	[paginator]="true"
	[(selection)]="selectedEntities"
	[loading]="loading"
	[rowHover]="true"
	[showCurrentPageReport]="true"
	dataKey="id"
	currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}"
	class="custom-table"
	styleClass="p-datatable-striped"
>
	<!-- CAPTION -->
	<ng-template pTemplate="caption">
		<div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
			{{ 'tableManagement.sanction.sanction' | translate }}
		</div>
	</ng-template>

	<!-- HEADERS -->
	<ng-template pTemplate="header">
		<tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
			<!-- VEHICLE -->
			<th pSortableColumn="vehicle.name">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'general.vehicle' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="vehicle.name"></p-sortIcon>
						<p-columnFilter
							field="vehicle"
							type="text"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						>
						</p-columnFilter>
					</div>
				</div>
			</th>

			<!-- DRIVER -->
			<th pSortableColumn="driver.employee.user.surname1">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.sinister.driver' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="driver.employee.user.surname1"></p-sortIcon>
						<p-columnFilter
							field="driver"
							type="text"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						>
						</p-columnFilter>
					</div>
				</div>
			</th>

			<!-- REASON -->
			<th pSortableColumn="reason.reason">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.sanction.reason' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="reason.reason"></p-sortIcon>
						<p-columnFilter
							field="reason"
							type="text"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						>
						</p-columnFilter>
					</div>
				</div>
			</th>

			<!-- DATE -->
			<th pSortableColumn="date">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.sanction.date' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="date"></p-sortIcon>
						<p-columnFilter
							field="sanctionDate"
							type="date"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						>
						</p-columnFilter>
					</div>
				</div>
			</th>

			<!-- ISSUER -->
			<th pSortableColumn="issuer">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.sanction.issuer' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="issuer"></p-sortIcon>
						<p-columnFilter
							field="issuer"
							type="text"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						>
						</p-columnFilter>
					</div>
				</div>
			</th>

			<!-- AMOUNT -->
			<th pSortableColumn="amount">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.sanction.amount' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="amount"></p-sortIcon>
					</div>
				</div>
			</th>

			<!-- POINTS -->
			<th pSortableColumn="points">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.sanction.points' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="points"></p-sortIcon>
					</div>
				</div>
			</th>

			<!-- DISCOUNT PAYROLL -->
			<th pSortableColumn="discountPayroll">
				<div class="d-flex align-items-center h-100">
					<div class="d-flex align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.sanction.discountPayroll' | translate }}
					</div>
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="discountPayroll"></p-sortIcon>
						<p-columnFilter field="discountPayroll" type="boolean" display="menu" [showApplyButton]="false">
						</p-columnFilter>
					</div>
				</div>
			</th>

			<!-- DELETE -->
			<th class="button-column"></th>
		</tr>
	</ng-template>

	<!-- BODY -->
	<ng-template pTemplate="body" let-sanction>
		<tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="openDialog(sanction)">
			<td>{{ sanction.vehicle?.name }}</td>

			<td>
				{{ sanction.driver?.employee?.user?.surname1 }} {{ sanction.driver?.employee?.user?.surname2 }},
				{{ sanction.driver?.employee?.user?.name }}
			</td>

			<td>{{ sanction.reason?.reason }}</td>

			<td>{{ sanction.date | date: 'dd/MM/yyyy' }}</td>

			<td>{{ sanction.issuer }}</td>

			<td>{{ sanction.amount }}</td>

			<td>{{ sanction.points }}</td>

			<td>
				<div class="d-flex justify-content-center align-items-center">
					<i
						class="pi"
						[ngClass]="{
							'true-icon pi-check-circle': sanction.discountPayroll,
							'false-icon pi-times-circle': !sanction.discountPayroll,
						}"
					></i>
				</div>
			</td>

			<td>
				@if (isDeleteGranted) {
					<button type="button" class="btn custom-table-remove-button" (click)="onDeleteSanction(sanction)">
						<svg-icon
							src="assets/icons/trash.svg"
							class="d-flex flex-wrap custom-table-remove-button-icon"
							[svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
						></svg-icon>
					</button>
				}
			</td>
		</tr>
	</ng-template>

	<!-- EMPTY MESSAGE -->
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="9" class="p-0">
				<div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message">
					{{ 'table.tableEmptyMessage' | translate }}!
				</div>
			</td>
		</tr>
	</ng-template>

	<!-- FOOTER -->
	<ng-template pTemplate="footer">
		<tr>
			<td colspan="9" class="p-0">
				<div class="d-flex flex-row align-items-center p-3 gap-3">
					@if (isCreateGranted) {
						<app-table-add-button [text]="'tableManagement.sanction.sanction' | translate" (btnClick)="create()">
						</app-table-add-button>
					}
					<app-table-excel-button class="buttonTableExcel" (btnClick)="exportExcel()"></app-table-excel-button>
				</div>
			</td>
		</tr>
	</ng-template>
</p-table>

<!-- FORM -->
<app-sanction-form [vehicle]="vehicle" [driver]="driver"></app-sanction-form>

<p-confirmDialog
	#sanctionConfirmDialog
	[header]="'confirm.critic' | translate"
	[message]="'control-panel.delete-dialog.message' | translate"
	class="custom-dialog"
	icon="pi pi-exclamation-triangle"
	key="sanction-list"
>
	<ng-template pTemplate="footer">
		<button (click)="sanctionConfirmDialog.onReject()" class="custom-button">{{ 'general.no' | translate }}</button>
		<button (click)="sanctionConfirmDialog.onAccept()" class="custom-button">{{ 'general.yes' | translate }}</button>
	</ng-template>
</p-confirmDialog>
